/* eslint-disable no-console */
import { action, observable, runInAction, configure } from "mobx";
import { CommonRuntime, getRuntime } from "utils/runtime";
import {
	ReceivedCouponInfo,
	getCustomerCouponInfo,
	ReceivedCouponStatusEnum,
} from "utils/zeusFetch";

configure({ isolateGlobalState: true, enforceActions: "observed" });
export class ReceiveCouponStore {
	@observable couponsInfo: Record<string, ReceivedCouponInfo> = {};

	@action.bound
	async updateCouponInfo(campaign_key: string, runtime?: Partial<CommonRuntime>) {
		runtime = getRuntime();
		if (!runtime.sessionKey) return;
		try {
			const resp = await getCustomerCouponInfo(
				{
					campaign_key,
					sid: runtime.sid,
					sessionkey: runtime.sessionKey,
					currency: runtime.currency,
					language: runtime.languageCode,
					country: runtime.countryCode3,
				},
				runtime as CommonRuntime
			);

			if (resp.result !== "success") throw new Error(resp.error_msg[0]);

			// 更新领取型优惠券状态
			runInAction(() => {
				this.couponsInfo[campaign_key] = resp.info;
			});
		} catch (error) {
			console.log(error);
		}
	}

	/**
	 * 获取优惠券信息
	 * @param campaign_key key
	 */
	@action.bound
	getCouponInfoByCampaignKey = (campaign_key: string) => {
		if (Reflect.has(this.couponsInfo, campaign_key)) {
			return this.couponsInfo[campaign_key];
		}
	};

	@action.bound
	readonly hydrate = (data: { receiveCoupon: Record<string, ReceivedCouponInfo> }) => {
		if (!data) return;
		this.couponsInfo = data.receiveCoupon !== null ? data.receiveCoupon : {};
	};
}

export { ReceivedCouponStatusEnum };
